import { mkTaxLineItem, type TaxLineItem, type TaxLineItemProps } from './taxLineItemsTypes';

export function transformResponseToTaxLineItems(
  response?: { data?: { resources?: TaxLineItemProps[] } } | null,
): TaxLineItem[] {
  const resources = response?.data?.resources;
  if (!Array.isArray(resources)) {
    throw new TypeError('Tax line items response is missing resources');
  }

  return resources.map((data) =>
    mkTaxLineItem({
      id: data.id,
      formId: data.formId,
      txfId: data.txfId,
      name: data.name,
      description: data.description,
      displayOrder: data.displayOrder,
    }),
  );
}
